<template>
  <v-card class="secondary" height="100%">
    <v-form ref="form">
      <v-card-title class="font-weight-medium secondary--text primary">
        Set Bulk Payments
        <v-spacer></v-spacer>
        <v-btn small icon @click="$emit('update')">
          <v-icon small color="secondary">mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-5">
        <v-row>
          <v-col cols="6">
            <v-text-field
              v-model="title"
              label="Payment"
              outlined
              dense
              hide-details="auto"
              readonly
          /></v-col>
          <v-col cols="6">
            <v-menu
              v-model="showDatePicker"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="formattedFromDate"
                  prepend-inner-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  label="Transaction Date*"
                  outlined
                  dense
                  hide-details="auto"
                  :rules="[rules.required]"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="form.transaction_date"
                :max="maxTransactionDate"
                @input="showDatePicker = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="6">
            <v-text-field
              v-model="form.amount"
              label="Transaction Amount*"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.required, rules.float]"
          /></v-col>
          <v-col cols="6"
            ><v-text-field
              v-model.trim="form.transaction_id"
              label="UTR*"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.required]"
          /></v-col>
          <v-col cols="6">
            <v-file-input
              v-model="form.fileUpload"
              outlined
              dense
              accept=".csv"
              hide-details="auto"
              :rules="[rules.required]"
              prepend-inner-icon="mdi-file-upload"
              prepend-icon=""
              label="Upload CSV"
            >
              <template v-slot:selection="{ text }">
                <span class="text-body-2 text-truncate" style="max-width: 100%">
                  {{ form.fileUpload ? form.fileUpload.name : text }}
                </span>
              </template>
            </v-file-input>
          </v-col>
          <v-col cols="6"
            ><v-text-field
              v-model.trim="form.no_of_students"
              label="Number Of Students*"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.required, rules.number]"
          /></v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pt-0 mx-2">
        <v-spacer></v-spacer>
        <v-btn class="primary" @click="save" :loading="loading"> Save</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>
<script>
import { rules } from "@/helpers/rules";

export default {
  props: {
    title: {
      type: String,
      default: () => "Admission",
    },
    partnerId: {
      type: Number,
      default: () => 0,
    },
  },
  data() {
    return {
      rules,
      form: {},
      showDatePicker: false,
      loading: false,
    };
  },
  computed: {
    formattedFromDate() {
      if (!this.form.transaction_date) return "";
      const [year, month, day] = this.form.transaction_date.split("-");
      return `${day}-${month}-${year}`;
    },
    currentUser() {
      return this.$store.state.currentUser;
    },
    maxTransactionDate() {
      return new Date().toISOString().slice(0, 10);
    },
  },
  created() {},
  methods: {
    async save() {
      if (!this.$refs.form.validate()) return;
      this.loading = true;
      const formData = new FormData();
      Object.keys(this.form).map((key) => {
        if (key == "fileUpload") {
          formData.append(
            "file",
            this.form.fileUpload,
            this.form.fileUpload.name,
          );
        } else {
          formData.append(key, this.form[key]);
        }
      });
      formData.append("partner_id", this.partnerId);
      formData.append("created_by", this.currentUser.email);
      formData.append("payment_type", this.title);

      await this.$axios
        .post("/upload_bulk_payments", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          this.loading = false;
          if (response.status === 201) {
            this.$emit("error", response.data);
            return;
          }

          this.$store.commit("showSnackbar", {
            message: "Uploaded Successfully",
            color: "success",
          });
          this.$emit("update");
        })
        .catch(async (error) => {
          this.loading = false;
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response,
          );
          if (errorMessage == "Uploaded csv has invalid headers")
            this.form.fileUpload = null;
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
  },
};
</script>

<style scoped></style>
